class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.$input = this.querySelector('input[type="search"]');
    this.$predictiveSearchResults = this.querySelector('#predictiveSearchSection');
    this.$trendingTerms = this.querySelector('.trending-terms');
    this.$trendingitem = this.querySelectorAll('.trending-term');
    this.$popularTitle = this.querySelector('.popular-title');
    this.$searchResult = this.querySelector('.search-results');
    this.$searchNoResult = this.querySelector('.no-result');
    this.$predictiveSearchSection = this.querySelector('.popular-containter');
    

    if (!this.$input) {
      console.error("Search input not found!");
      return;
    }

    // Add event listener for input changes
    this.$input.addEventListener("input", this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Add event listener to trending search terms
    this.$trendingitem.forEach(term => {
      term.addEventListener("click", () => {
        this.onTrendingTermClick(term);
      });
    });
  }

  onChange() {
    const searchTerm = this.$input.value.trim();
  
    if (!searchTerm.length) {
      this.close();
  
      // ✅ Show trending searches and popular products
      this.$trendingTerms.style.display = "block";
      this.$popularTitle.style.display = "block";
      this.$searchResult.style.display = "none"; // Hide search results
      this.$searchNoResult.style.display = "none"; // Hide no results message
  
      // ✅ Restore the default product list
      this.$predictiveSearchResults.innerHTML = this.$predictiveSearchSection.innerHTML;
  
      this.open(); // Show default products
  
      return;
    }
  
    this.getSearchResults(searchTerm);
  }
  
  

  onTrendingTermClick(term) {
    const searchTerm = term.getAttribute('data-term');
    this.$input.value = searchTerm; // Fill input field with trending term
    this.getSearchResults(searchTerm); // Trigger search
  }

  getSearchResults(searchTerm) {
    $.ajax({
      url: `/search/suggest?q=${searchTerm}&section_id=predictive-search`,
      method: "GET",
      success: (res) => {
        let totalResults = 0; // Initialize count variable
        const resultMarkup = $(new DOMParser().parseFromString(res, 'text/html')).find("#predictiveSearchSection").html();
        
        if (this.$predictiveSearchResults) {
          this.$predictiveSearchResults.innerHTML = resultMarkup; 
          this.open();
  
          // ✅ Wait for DOM to update before counting results
          setTimeout(() => {
            totalResults = this.$predictiveSearchResults.querySelectorAll(".popular-product").length;
  
            if (totalResults > 0) {
              this.$searchResult.style.display = "block";
              this.$searchResult.querySelector(".count").textContent = `${totalResults} results`;
              this.$trendingTerms.style.display = "none";
              this.$popularTitle.style.display = "none";
              this.querySelector('.popular-products').style.display="block";
              this.$searchNoResult.style.display = "none";
            } 
            if( totalResults <= 0){
               this.querySelector('.popular-products').style.display="none";
               this.$searchNoResult.style.display = "block";
            }
          }, 50); // Small delay to ensure DOM is updated
        }
      },
      error: () => {
        this.close();
      }
    });
  }
  

  open() {
    if (this.$predictiveSearchResults) this.$predictiveSearchResults.style.display = "flex";
  }

  close() {
    if (this.$predictiveSearchResults) this.$predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
